import { getAnalytics } from 'common/analytics';
import endsWith from 'lodash/endsWith';

const trackDataLink = link => {
  getAnalytics().track(
    link.getAttribute('data-tracking-link-name'),
    JSON.parse(link.getAttribute('data-tracking-link-props'))
  );
};

// Generic link click tracking
const trackGenericLink = link => {
  const linkTrackingParent = link.closest('*[data-tracking-event-name]');

  if (link.href && !endsWith(link.href, '/#') && linkTrackingParent) {
    const eventName = linkTrackingParent.dataset.trackingEventName;
    let linkText = link.textContent.trim();
    const linkImg = link.querySelector('img');

    if (linkText === '' && linkImg) {
      linkText = linkImg.alt;
    }

    if (linkText !== '') {
      const eventProps = {
        referrer: document.referrer,
        path: window.location.pathname,
        link_url: link.href,
        link_text: linkText,
        has_image: !!linkImg,
      };

      getAnalytics().track(eventName, eventProps);
    }
  }
};

document.addEventListener('click', e => {
  if (e.target.tagName.toLowerCase() === 'a') {
    const link = e.target;

    if (link.hasAttribute('data-tracking-link-name')) {
      trackDataLink(link);
    } else {
      trackGenericLink(link);
    }
  }
});
